@use 'src/globals/main';

pn-page-nav {
  display: block;
  position: relative;
  font-size: clamp(0.8em, 2vw, 1em);
  z-index: 5;
}

.pn-page-nav-wrapper {
  transform: translateZ(0);
  font-size: inherit;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  display: inline-flex;
  border-radius: 3em;
}

.pn-page-nav {
  display: flex;
  align-items: center;
  border-radius: 3em;
  min-height: 3em;
  background: main.$blue900;
  border: 0.0625em solid main.$gray200;
  position: relative;
  overflow-x: auto;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }
}

.pn-page-nav ul.pn-page-nav-items {
  display: flex;
  list-style-type: none;
  padding: 0.25em;
  margin: 0;
  position: relative;
}

.pn-page-nav-items > .pn-pn-bg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  will-change: transform;
  left: 0;
  border-radius: 3em;
  transition:
    width 0.25s cubic-bezier(0.29, 0.15, 0.24, 0.97),
    transform 0.25s cubic-bezier(0.29, 0.15, 0.24, 0.97),
    background 0.15s,
    opacity 0.15s,
    box-shadow 0.15s;

  &.pn-pn-active {
    box-shadow:
      0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
      0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
    background: main.$blue700;
    z-index: 1;
  }

  &.pn-pn-hover {
    background: main.$white;
    opacity: 0;
    border: 0.0625em solid transparent;
    z-index: 0;
  }

  &.hidden {
    opacity: 0;
  }
}

@media (hover: hover) {
  ul.pn-page-nav-items:focus-within .pn-pn-hover,
  ul.pn-page-nav-items:hover .pn-pn-hover {
    opacity: 0.12;
  }
}

/*---------------------------------------ARROWS-------------------------------------------*/
pn-page-nav .pn-pn-arrows {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
  padding: 0.125em 0.1em;

  svg {
    width: 1.5em;

    &.pn-icon-svg path {
      fill: main.$blue700;
    }
  }

  > * {
    transition:
      transform 0.2s,
      opacity 0.2s,
      background 0.1s,
      box-shadow 0.1s;
    pointer-events: all;
    height: 100%;
    aspect-ratio: 1;
    background: main.$white;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    opacity: 0;
    will-change: transform;
    -webkit-tap-highlight-color: transparent;
    border-radius: 50%;
    border: 0.0625em solid main.$blue900;

    &.pn-pn-arrow-left {
      transform: translateX(-100%);
    }

    &.pn-pn-arrow-right {
      transform: translateX(100%);
    }

    @media screen and (max-width: 30em) {
      border: none;

      pn-icon .pn-icon-svg {
        width: 100%;
        height: 2em;
        animation: arrow 0.6s ease-in-out alternate infinite;

        path {
          fill: main.$white;
        }
      }

      &.pn-pn-arrow-left {
        background: linear-gradient(to left, transparent, main.$blue900 60%);
        border-radius: 50% 0 0 50%;
      }

      &.pn-pn-arrow-right {
        background: linear-gradient(to right, transparent, main.$blue900 40%);
        border-radius: 0 50% 50% 0;
      }
    }
  }

  &.pn-pn-left-visible .pn-pn-arrow-left,
  &.pn-pn-right-visible .pn-pn-arrow-right {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes arrow {
  to {
    transform: translateX(10%);
  }
}
/*---------------------------------------/ARROWS-------------------------------------------*/

/*---------------------------------------DROPDOWN-------------------------------------------*/
button.pn-page-nav-dropdown-button {
  font-size: 1em;
  border-radius: 3em 0 0 3em;
  background: main.$blue900;
  color: main.$white;
  padding: 0.5em 1em 0.5em 1.5em;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  transition: background 0.15s;
  outline: none;
  height: 100%;
  position: relative;
  margin: 0 0.5em 0 0;
  font-weight: 500;

  pn-icon {
    margin-left: 0.5em;
  }

  &:hover,
  &:focus {
    background: #263655;
  }

  &:focus {
    box-shadow:
      inset 0 0 0 0.1em main.$blue700,
      inset 0 0 0 0.2em main.$gray200;
  }

  &.pn-page-nav-dropdown-active {
    background: main.$blue700;

    &:hover,
    &:focus {
      background: main.$blue700;
    }
  }
}

.pn-page-nav-divider {
  height: 60%;
  background: main.$gray200;
  width: 0.1em;
  position: absolute;
  right: 0;
  transform: translateX(50%);
}

ul.pn-page-nav-dropdown {
  position: absolute;
  left: 0;
  top: 110%;
  background: main.$blue900;
  border-radius: 0.5em;
  margin: 0;
  padding: 0;
  list-style-type: none;
  box-shadow:
    0px 6.400000095367432px 14.399999618530273px 0px #00000021,
    0px 1.2000000476837158px 3.5999999046325684px 0px #0000001a;
  font-size: inherit;
  display: none;
}

ul.pn-page-nav-dropdown.pn-page-nav-dropdown-open {
  display: block;
}
/*---------------------------------------/DROPDOWN-------------------------------------------*/
